"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var RadioButton_less_1 = __importDefault(require("./RadioButton.less"));
var RadioButton = function (_a) {
    var _b, _c, _d;
    var disabled = _a.disabled, selected = _a.selected, className = _a.className, label = _a.label, ariaLabel = _a.ariaLabel, onChange = _a.onChange, error = _a.error;
    var handleSelect = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        if (!disabled && onChange) {
            onChange(target.checked);
        }
    }, [disabled, onChange]);
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && !disabled) {
            event.preventDefault();
            onChange && onChange(!selected);
        }
    }, [disabled, selected, onChange]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(RadioButton_less_1.default['radio-button'], className) },
        react_1.default.createElement("label", null,
            label,
            react_1.default.createElement("div", { className: (0, classnames_1.default)(RadioButton_less_1.default['radio-container'], (_b = {}, _b[RadioButton_less_1.default['selected']] = selected, _b), (_c = {}, _c[RadioButton_less_1.default['disabled']] = disabled, _c), (_d = {}, _d[RadioButton_less_1.default['error']] = error, _d)), role: 'radio', tabIndex: disabled ? -1 : 0, "aria-checked": selected, "aria-label": ariaLabel, onKeyDown: onKeyDown },
                react_1.default.createElement("input", { type: 'radio', checked: selected, disabled: disabled, onChange: handleSelect, onClick: selected ? function () { return onChange === null || onChange === void 0 ? void 0 : onChange(true); } : undefined, tabIndex: -1, "aria-hidden": true, className: RadioButton_less_1.default['input'] }),
                react_1.default.createElement("span", { className: RadioButton_less_1.default['inner-circle'] })))));
};
exports.default = RadioButton;
